// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__DUW1R","header":"ReportDetails_header__3MihJ","title":"ReportDetails_title__2UE7E","left":"ReportDetails_left__w5UWf"};